import type { ReactNode } from 'react'
import { Avatar } from '../ui'

// The author's home at the foot of a writing (out of the header): who wrote
// it, how many writings they have, and — beside that count — Think Along
// (follow), or the author's own actions. Shared by the public reader and the
// author's Preview, so Preview shows exactly what readers get.

interface Props {
  name: string
  avatarUrl: string | null | undefined
  /** Published writings; the count hides until it's known. */
  count: number | undefined
  /** Think Along, or the author's own buttons. */
  children: ReactNode
}

export function AuthorBlock({ name, avatarUrl, count, children }: Props) {
  return (
    <section
      aria-label="About the author"
      className="mt-10 flex flex-wrap items-center justify-between gap-5 rounded-2xl border border-card-edge bg-card px-6 py-[22px] font-sans"
    >
      <div className="flex min-w-0 items-center gap-3.5">
        <Avatar src={avatarUrl} name={name} size={48} />
        <div className="flex min-w-0 flex-col gap-[3px]">
          <span className="text-[10.5px] font-semibold tracking-[0.08em] text-muted-foreground">WRITTEN BY</span>
          <span className="truncate font-display text-[19px] text-primary">{name}</span>
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-3">
        {count !== undefined && (
          <span className="whitespace-nowrap rounded-full bg-muted/50 px-3 py-1 text-[13px] font-medium text-muted-foreground">
            {count} writing{count === 1 ? '' : 's'}
          </span>
        )}
        {children}
      </div>
    </section>
  )
}
